import React from "react";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Main from "./Main";
import Permission from "./Permission";
import Logout from "./Logout";
import AuthControl from "./AuthControl";
import Error from "./components/Error";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:applicationId/:language" exact element={<Main />} />
        <Route
          path="/permissions/:applicationId/:language"
          element={<Permission />}
        />
        <Route
          path="/:applicationId/:language/:targetUser"
          element={<Main />}
        />
        <Route path="/:applicationId/:language" element={<Main />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/callback" element={<AuthControl />} />
        <Route path="/error" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
